<template>
    <div class="login-page-wrapper feed-back-page-wrapper" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container">
            <!--<alert v-model="success" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
                <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                <!--<strong>Sent!</strong>-->
                <!--<p id="contactus_successmsg">{{successMsg}}</p>-->
            <!--</alert>-->
            <div class="row">
                <div class="col-md-12">
                    <div class="main-content">
                        <h2 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">Feedback</h2>
                        <p>We’d love to hear from you.</p>
                    </div>
                </div>
                <div class="col-md-8 col-md-offset-2">
                    <div class="form">
                        <form id="fb_form" v-on:submit.prevent="onSubmit">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-minus">
                                <div v-if="!user">
                                    <bs-input label="Name" v-model="feedbackForm.name"
                                              id="feedback_name"
                                              type="text"
                                              class="form-input"
                                              error="Name"
                                              placeholder="Name"
                                              required
                                              >
                                    </bs-input>
                                    <bs-input label="Email Address" autocomplete="email" v-model="feedbackForm.email"
                                              id="feedback_email"
                                              type="email"
                                              class="form-input"
                                              error="Email Address"
                                              placeholder="Email Address"
                                              required
                                              >
                                    </bs-input>
                                </div>
                                <bs-input label="Comments" v-model="feedbackForm.comments"
                                          id="feedback_comments"
                                          type="textarea"
                                          class="form-input"
                                          error="Comments"
                                          placeholder="Comments"
                                          required
                                          >
                                </bs-input>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                <button :disabled="spinner" v-bind:style="{ color: $a11yInkColor(getCorpButtonColor) + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn formButton btn-transparent" id="feedback_submit">
                                    Send
                                    <spinner v-if="spinner" v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                </button>
                            </div>
                        </form>
                        <alert v-model="error.show" placement="top-right" duration="0" type="danger" width="400px" dismissable>
                            <span class="icon-info-circled alert-icon-float-left"></span>
                            <strong>Error:</strong>
                            <p id="contactus_errormsg">{{error.message}}</p>
                        </alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import checkbox from '@/accessibility/Checkbox'
    import { mapGetters } from 'vuex'
    // import StarRating from 'vue-star-rating'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            checkbox
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE | Feedback',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Feedback'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Feedback'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                feedbackForm: {
                    userId: null,
                    email: '',
                    name: '',
                    comments: '',
                    rating: 0,
                    newsLetterEmail: '0',
                    promotionalEmail: '0',
                    representativeCall: '0'
                },
                spinner: false,
                newsLetterEmailBool: '',
                promotionalEmailBool: '',
                representativeCallBool: ''
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        methods: {
            setRating: function (rating) {
                this.feedbackForm.rating = rating
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.user) {
                    this.feedbackForm.email = this.user.email
                    this.feedbackForm.name = this.user.firstName + ' ' + this.user.lastName
                    this.feedbackForm.userId = this.user.userId
                } else {
                    this.userId = null
                }
                if (this.feedbackForm.email && this.feedbackForm.name) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDFEEDBACKFORM', this.feedbackForm).then(() => {
                        window.logEvents('Feedback Page', 'Feedback Sent', `Feedback Email: ${this.feedbackForm.email}, Feedback: ${this.feedbackForm.comments}`)
                       // this.success = true
                       // this.successMsg = 'Thank you for your feedback!'
                        this.spinnerToggle()
                        this.$swal({
                            title: 'Thank you for your feedback!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .main-content p {
        font-size: 22px;
        font-family: sans-serif;
        letter-spacing: 0.5px;
        margin: 0 0 30px 0;
        font-weight: normal;
        line-height: 1;
        color: #777777;
    }
    .main-content h2 {
        color: #f0617d;
        text-transform: capitalize;
        margin: 40px 0 15px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
    }
</style>
<style>
    #feedback_comments textarea {
        height: 100px !important;
        max-width: 100%;
        min-width: 100%;
        max-height: 100px;
        min-height: 100px;
        resize: none;
    }
</style>



// WEBPACK FOOTER //
// Feedback.vue?5bbb4902